import { query, execute } from "./client.js";
import { supabase, useSupabase } from "./supabaseClient.js";

/**
 * List all taxes
 * @returns {Promise<Array>} Array of tax records
 */
export async function listTaxes() {
  if (useSupabase()) {
    const { data, error } = await supabase
      .from("taxes")
      .select("*")
      .order("name", { ascending: true });
    if (error) throw error;
    return data;
  }
  // Fallback to SQLite (if implemented in client.js)
  return await query("SELECT * FROM taxes ORDER BY name ASC");
}

/**
 * Add a new tax
 * @param {Object} tax - { name, rate }
 */
export async function addTax(tax) {
  if (useSupabase()) {
    const { data, error } = await supabase
      .from("taxes")
      .insert([tax])
      .select();
    if (error) throw error;
    return data[0];
  }
  // Fallback
  await execute(
    "INSERT INTO taxes (name, rate) VALUES (?, ?)",
    [tax.name, tax.rate]
  );
  return { ...tax }; // Simplified return for SQLite
}

/**
 * Delete a tax by ID
 * @param {number} id
 */
export async function deleteTax(id) {
  if (useSupabase()) {
    const { error } = await supabase
      .from("taxes")
      .delete()
      .eq("id_taxes", id);
    if (error) throw error;
    return true;
  }
  await execute("DELETE FROM taxes WHERE id_taxes = ?", [id]);
  return true;
}

/**
 * Update a tax
 * @param {number} id
 * @param {Object} updates - { name, rate }
 */
export async function updateTax(id, updates) {
  if (useSupabase()) {
    const { data, error } = await supabase
      .from("taxes")
      .update(updates)
      .eq("id_taxes", id)
      .select();
    if (error) throw error;
    return data[0];
  }
  // Fallback
  await execute(
    "UPDATE taxes SET name = ?, rate = ? WHERE id_taxes = ?",
    [updates.name, updates.rate, id]
  );
  return { id_taxes: id, ...updates };
}
